import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import PipelineStats from '../Stats/PipelineStats';
import MetricsDashboard from '../Metrics/MetricsDashboard';
import PipelineControls from './PipelineControls';

export default function PipelineDashboard() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Pipeline
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Statistics" />
        <Tab label="Trends" />
        <Tab label="Controls" />
      </Tabs>

      {activeTab === 0 && <PipelineStats />}
      {activeTab === 1 && <MetricsDashboard />}
      {activeTab === 2 && <PipelineControls />}
    </Box>
  );
}
